module.exports = "/assets/data/eb36d6de8789604b6974f9c77a5c0fc6-GL56.data.json";